// ============================================================
// api.js — URL de base de l'API
// Vide en local (proxy du dev server ou même origine que Express),
// (Render sert le frontend et l'API sur le même domaine). Surcharge possible via REACT_APP_API_URL
// ============================================================

import axios from 'axios';

export const API_URL = (process.env.REACT_APP_API_URL || '').replace(/\/$/, '');

axios.defaults.baseURL = API_URL;
